import { render, staticRenderFns } from "./CommonTableStore.vue?vue&type=template&id=51a68116"
import script from "./CommonTableStore.vue?vue&type=script&lang=js"
export * from "./CommonTableStore.vue?vue&type=script&lang=js"
import style0 from "./CommonTableStore.vue?vue&type=style&index=0&id=51a68116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports